export default function MarqueePortraitsRow2() {
  const images = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_20.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_21.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_22.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_23.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_24.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_25.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_26.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_17.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_18.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_19.png"];
  const verticalOffsets = [60, 20, 50, 30, 65, 25, 45, 55, 20, 40];
  const getBorderRadius = (index: number) => {
    const mod = index % 4;
    if (mod === 0) return "100px 100px 100px 1rem";
    if (mod === 1) return "100px 100px 1rem 100px";
    if (mod === 2) return "100px 1rem 100px 100px";
    return "1rem 100px 100px 100px";
  };
  const itemWidth = 200;
  const itemGap = 224;
  const itemCount = images.length;
  const totalWidth = itemCount * itemGap;
  const duration = 30;
  const allImages = [...images, ...images];
  return <section style={{
    backgroundColor: "#F5F4F2",
    width: "100%",
    height: "300px",
    position: "relative",
    overflow: "hidden",
    fontFamily: "Switzer, sans-serif"
  }}>
      <style>{`
        @keyframes marquee-go {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${totalWidth}px); }
        }
        .marquee-track {
          display: flex;
          align-items: flex-start;
          position: absolute;
          top: 0;
          left: 0;
          animation: marquee-go ${duration}s linear infinite;
          will-change: transform;
        }
        .marquee-wrapper {
          mask-image: linear-gradient(to right, rgba(0,0,0,0) 0%, rgb(0,0,0) 10%, rgb(0,0,0) 90%, rgba(0,0,0,0) 100%);
          -webkit-mask-image: linear-gradient(to right, rgba(0,0,0,0) 0%, rgb(0,0,0) 10%, rgb(0,0,0) 90%, rgba(0,0,0,0) 100%);
        }
      `}</style>
      <div className="marquee-wrapper" style={{
      position: "absolute",
      inset: 0,
      overflow: "hidden"
    }}>
        <div className="marquee-track">
          {allImages.map((src, i) => {
          const origIndex = i % images.length;
          const offsetTop = verticalOffsets[origIndex];
          const borderRadius = getBorderRadius(origIndex);
          return <div key={i} style={{
            width: `${itemWidth}px`,
            height: `${itemWidth}px`,
            flexShrink: 0,
            marginRight: `${itemGap - itemWidth}px`,
            marginTop: `${offsetTop}px`,
            backgroundColor: "#FFFFFF",
            borderRadius,
            overflow: "hidden",
            position: "relative"
          }}>
                <img src={src} alt="" className="w-full h-auto" style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center top",
              display: "block"
            }} />
              </div>;
        })}
        </div>
      </div>
    </section>;
}